import { render, staticRenderFns } from "./orders_tk.vue?vue&type=template&id=3143f27a&scoped=true"
import script from "./orders_tk.vue?vue&type=script&lang=js"
export * from "./orders_tk.vue?vue&type=script&lang=js"
import style0 from "./orders_tk.vue?vue&type=style&index=0&id=3143f27a&prod&lang=scss"
import style1 from "./orders_tk.vue?vue&type=style&index=1&id=3143f27a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3143f27a",
  null
  
)

export default component.exports